import { render, staticRenderFns } from "./EventTabs.vue?vue&type=template&id=1f4d1020&"
import script from "./EventTabs.vue?vue&type=script&lang=js&"
export * from "./EventTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports